import React, { useState } from 'react';
import { pageTitle } from '../PageTitle';
import BreadCrumb from '../BreadCrumb';
import HeaderOne from '../Header/HeaderTwo';
import FooterOne from '../Footer/FooterTwo';
import { Link } from 'react-router-dom';
import two from "../../assets/images/resource/choose-05.png";
import serviceImg from "../../assets/images/resource/service-details.jpg";
import basebg from "../../assets/images/resource/base.png";
import { useLocation } from 'react-router-dom';
import parse from 'html-react-parser';

const Services = () => {
    pageTitle('Services Details');
    const location = useLocation();
    const service = location.state.service;

    const services = location.state.services;

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        phone: '',
        message: ''
    });



    const handleSubmit = async (e) => {
        e.preventDefault();

        // Get form data
        const formDataObj = new FormData(e.target);
        const formObject = {
            name: formDataObj.get('name'),
            email: formDataObj.get('email'),
            subject: formDataObj.get('subject'),
            phone: formDataObj.get('phone'),
            message: formDataObj.get('message')
        };

        // Log the form data
        console.log('Contact Form Submission:', formObject);

        try {
            // Send data to API endpoint
            const response = await fetch('https://simsolver.epitomeri.com/api/user/epitomeri_contact_form_submission', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formObject)
            });

            if (response.ok) {
                const result = await response.json();
                console.log('Form submitted successfully:', result);
                alert('Message sent successfully!');
                e.target.reset(); // Clear the form
                // Clear the form state as well
                setFormData({
                    name: '',
                    email: '',
                    subject: '',
                    phone: '',
                    message: ''
                });
            } else {
                console.error('Form submission failed:', response.statusText);
                alert('Failed to send message. Please try again.');
            }
        } catch (error) {
            console.error('Error submitting form:', error);
            alert('An error occurred. Please try again later.');
        }
    };

    const servicesData = [...services];

    const renderServices = () => {
        return servicesData.map((service_) => (
            <li key={service_.id} className={service.title === service_.title ? 'active' : ''}>
                <Link className={service.title === service_.title ? 'active' : ''} to={service.title === service_.title ? '' : service_.href} state={{ service: service_, services: services }}>{service_.title}</Link>
            </li>
        ));
    };

    return (

        <>
            <HeaderOne></HeaderOne>
            <BreadCrumb title={service.title}></BreadCrumb>
            <div className="service__details p_relative ">
                <div className="auto-container">
                    <div className="row">
                        <div className="col-xl-4 col-lg-6 col-md-12">
                            <div className="service__details__left">
                                <div className="sidebar__widget">
                                    <div className="all__service">
                                        <h3>All Services</h3>
                                    </div>
                                    <ul className="service__details__1__cat">
                                        {renderServices()}
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="col-xl-8 col-lg-12 col-md-12">
                            <div className="service__right">
                                {/* <figure>
                                    <img src={serviceImg} alt="" />
                                </figure> */}
                                <div className='service__content'>
                                    {parse(service.content)}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="service__contact see__pad p_relative">
                <div className="auto-container">
                    <div className="service__contact__block">
                        <div className="row">
                            <div className="col-lg-6 col-md-12">
                                <div className="service__form__data">
                                    <div className="form__title">
                                        <div className="title__data">
                                            <div className="sub__title">
                                                <h4>Contact Us</h4>
                                            </div>
                                            <div className="title">
                                                <h2>Send message</h2>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="form-inner">
                                        <form onSubmit={handleSubmit} method="post" action="contact.php" className="default-form">
                                            <div className="row clearfix">
                                                <div className="col-xl-6 form-group">
                                                    <input type="name" name="name" placeholder="Your Name *" required="" />
                                                </div>
                                                <div className="col-xl-6 col-lg-12 form-group">
                                                    <input type="email" name="email" placeholder="Your Email *" required="" />
                                                </div>
                                                <div className="col-xl-6 col-lg-12 form-group">
                                                    <input type="text" name="subject" placeholder="Your Subject " required="" />
                                                </div>
                                                <div className="col-xl-6 col-lg-12 form-group">
                                                    <input type="text" name="phone" placeholder="Your Phone " required="" />
                                                </div>
                                                <div className="ccol-xl-6 col-lg-12 form-group">
                                                    <textarea name="message" placeholder="Message"></textarea>
                                                </div>
                                                <div className="col-xl-12 form-group message-btn btn-box">
                                                    <button className="theme-btn theme-btn-one" type="submit" name="submit-form">Send your Message</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 col-md-12 p_relative">
                                <div className="service__contact__img">
                                    <figure>
                                        <img src={two} alt=" /" />
                                    </figure>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <FooterOne></FooterOne>
        </>
    );
};

export default Services;
